// extracted by mini-css-extract-plugin
export default {"server-fallback":"hawk-master-widget-server-fallback","serverFallback":"hawk-master-widget-server-fallback"};